import libphonenumber from 'google-libphonenumber';

export const formatPhone = phone => {
  if (phone && phone.length < 9) return phone;
  const PNF = libphonenumber.PhoneNumberFormat;
  const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();

  const parsedPhone = phoneUtil.parse(phone, 'US');
  return phoneUtil.format(parsedPhone, PNF.INTERNATIONAL);
};



// WEBPACK FOOTER //
// ./src/utils/converters/phoneFormatter.js